import { Link, NavLink } from "react-router-dom";
import { CalendarCheck2 } from "lucide-react";
import { navLinks, siteConfig } from "@/content/siteData";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  return (
    <header className="fixed top-0 z-40 w-full px-4 py-3 sm:px-8" data-testid="site-navbar">
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex w-full items-center justify-between rounded-2xl border border-white/50 bg-white/70 px-4 py-3 backdrop-blur-md soft-card sm:px-6">
          <Link
            to="/"
            className="text-xl font-semibold text-primary transition-colors duration-300 hover:text-secondary"
            data-testid="navbar-brand-link"
          >
            {siteConfig.brand}
          </Link>

          <nav className="hidden items-center gap-5 md:flex" data-testid="navbar-links">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`navbar-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors duration-300 ${
                    isActive ? "text-primary" : "text-foreground/80 hover:text-primary"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            <Button
              asChild
              className="h-10 rounded-full bg-accent px-4 text-sm font-bold text-accent-foreground transition-transform duration-300 hover:scale-105"
              data-testid="navbar-book-trial-button"
            >
              <Link to="/contact">
                <CalendarCheck2 className="h-4 w-4" />
                Book Free Trial
              </Link>
            </Button>
          </div>
        </div>

        <nav
          className="mt-2 flex flex-wrap gap-2 rounded-2xl border border-white/50 bg-white/70 p-2 backdrop-blur-md md:hidden"
          data-testid="navbar-mobile-links"
        >
          {navLinks.map((item) => (
            <NavLink
              key={`mobile-${item.path}`}
              to={item.path}
              data-testid={`navbar-mobile-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `rounded-full px-3 py-1 text-xs font-medium transition-colors duration-300 ${
                  isActive ? "bg-primary text-white" : "text-foreground/80 hover:bg-muted"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};